module.exports = __webpack_public_path__ + "static/media/pink@2x.73f66bcb.png";